import { Link } from "react-router-dom";

// Plovoucí hlavní akce pro mobil (nad spodní lištou). Na desktopu skryto (CSS .fab).
export function Fab({ icon: Icon, label, onClick, to, testid }) {
    const inner = (<><Icon className="w-5 h-5" />{label}</>);
    if (to) return <Link to={to} className="fab" data-testid={testid} aria-label={label}>{inner}</Link>;
    return <button type="button" onClick={onClick} className="fab" data-testid={testid} aria-label={label}>{inner}</button>;
}
